import API from 'services/API';

export default function getQesParticipation() {
  return API.request({
    method: 'GET',
    url: '/profile/orgStatusQes',
  });
}
